import { render, staticRenderFns } from "./UploadDocs.vue?vue&type=template&id=d5d0051c"
import script from "./UploadDocs.vue?vue&type=script&lang=js"
export * from "./UploadDocs.vue?vue&type=script&lang=js"
import style0 from "./UploadDocs.vue?vue&type=style&index=0&id=d5d0051c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports